export default "__VITE_ASSET__C3fLk50m__"